var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cl from 'clsx';
import { BodyShort, Detail, ErrorMessage, Label } from 'components/typography';
import React, { forwardRef, useRef } from 'react';
import { omit } from 'util/index';
import { useFormField } from '../useFormField';
export const Slider = forwardRef((props, ref) => {
    var _a, _b;
    const { inputProps, errorId, showErrorMsg, hasError, size, inputDescriptionId } = useFormField(props, 'textField');
    const { label, className, description, htmlSize, hideLabel = false, active = 'both', onChange } = props, rest = __rest(props, ["label", "className", "description", "htmlSize", "hideLabel", "active", "onChange"]);
    const thumbRef = useRef(null);
    const trackInnerRef = useRef(null);
    const handleOnChange = (e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
        updateSlider(e.target.value);
    };
    const updateSlider = (value) => {
        if (thumbRef.current) {
            thumbRef.current.style.left = `${value}%`;
            thumbRef.current.style.transform = `translate(-${value}%, -50%)`;
        }
        if (trackInnerRef.current) {
            trackInnerRef.current.style.width = `${value}%`;
        }
    };
    updateSlider((_b = (_a = props.value) !== null && _a !== void 0 ? _a : props.defaultValue) !== null && _b !== void 0 ? _b : '0');
    return (React.createElement("div", { className: cl(className, 'cds-form-field', `cds-form-field--${size}`, {
            'cds-slider--error': hasError,
            'cds-slider--disabled': !!inputProps.disabled,
            'cds-form-field--disabled': !!inputProps.disabled
        }) },
        React.createElement(Label, { htmlFor: inputProps.id, size: size, as: 'label', className: cl('cds-form-field__label', {
                'cds-sr-only': hideLabel
            }) }, label),
        !!description && (React.createElement(React.Fragment, null, size === 'medium'
            ? (React.createElement(BodyShort, { className: cl('cds-form-field__description', {
                    'cds-sr-only': hideLabel
                }), id: inputDescriptionId, size: 'small', as: 'div' }, description))
            : (React.createElement(Detail, { className: cl('cds-form-field__description', {
                    'cds-sr-only': hideLabel
                }), id: inputDescriptionId, size: 'small', as: 'div' }, description)))),
        React.createElement("div", { className: 'cds-slider__wrap' },
            React.createElement("input", Object.assign({}, omit(rest, ['error', 'errorId', 'size']), inputProps, { onChange: handleOnChange, ref: ref, type: 'range', className: cl('cds-slider__input', 'cds-body-short', `cds-body-${size !== null && size !== void 0 ? size : 'medium'}`), size: htmlSize })),
            React.createElement("div", { className: cl('cds-slider__track', `cds-slider__active-${active}`) },
                React.createElement("div", { ref: trackInnerRef, className: 'cds-slider__track-inner' })),
            React.createElement("div", { ref: thumbRef, className: 'cds-slider__thumb' })),
        React.createElement("div", { className: 'cds-form-field__error', id: errorId, "aria-relevant": 'additions removals', "aria-live": 'polite' }, showErrorMsg && (React.createElement(ErrorMessage, { size: size }, props.error)))));
});
Slider.displayName = 'Slider';
export default Slider;
